export default "__VITE_ASSET__DqAAon6Z__"